//
// Decide which scout photos need to be cached locally depending on user, role, and assigned scouts
//
import { Injectable } from '@angular/core';
import Dexie from 'dexie';
import { AppState } from '../app-state';
import { ScoutPointLocalPhoto, ScoutPointLocalPhotoUrl } from '../models/scout-task';
import { TestbedCollectionService } from './testbed-rxdb/testbed-collection.service';

//TODO - give this class legit file if used for more than scout photos
export abstract class TestbedDexieCollectionService<ModelType> extends TestbedCollectionService<ModelType> {

  constructor( 
      appState : AppState ) {
    super(appState)
  }

  abstract get dexieStore() : Dexie.Table<ModelType,string>

  async update(doc: ModelType, changes: {[keyPath: string]: any}) {
    const updateCnt = await this.dexieStore.update(doc,changes)
    // RXDB atomicUpdate updates the fields of input doc so mimic that here...
    Object.assign(doc,changes)
    return updateCnt
  }

  where = (equalityCriterias: {[key: string]: any}) => this.dexieStore.where(equalityCriterias)

  async getById(id: string) {
      const val = await this.dexieStore.get(id)
      return val
  }
}



@Injectable({ providedIn: 'root' })
export class ScoutLocalDbService extends Dexie {

  scoutPointLocalPhotoUrls!: Dexie.Table<ScoutPointLocalPhotoUrl, string>;
  scoutPointLocalPhotos!: Dexie.Table<ScoutPointLocalPhoto, string>;

  constructor(appState: AppState) {
    super(appState.settings.getEnvName().toLowerCase() + '_scout_local_db')
    this.version(1).stores({
      scoutPointLocalPhotoUrls: '&_id',
      scoutPointLocalPhotos: '&_id,uploadDate,[uploadDate+errorMsg],[uploadStartDate+uploadDate+errorMsg]'
    })
  }

}